<div [matTooltip]="'Connection line'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    class="text-[18px]"
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-link'"
    (click)="selectTool.emit()"
  >
    <fa-icon [icon]="['fal', 'arrow-right']" transform="rotate--45"></fa-icon>
  </button>
</div>
